export default __webpack_public_path__ + "img/preguntas-frecuentes.dfc0494b.png";